<template>
  <div class="modal-video" v-if="isVisible" @click.self="closeModal">
    <div class="modal-content">
      <div class="modal-header">
        <div class="youtube-icon">
          <img :src="youtobelogo" alt="YouTube Icon" />
          <img class="bilibili-icon" :src="bilibililogo" alt="Bilibili Icon" />
        </div>
        <!-- <h2>YouTube Video</h2> -->
        <h2>YouTube / Bilibili Video</h2>
      </div>
      <div class="input-container">
        <input type="text" placeholder="Paste a YouTube or Bilibili link. Max time:4 hours" v-model="youtubeLink" ref="videoInput" />
      </div>
      <selectlanguage :chooeseLanguage="chooeseLanguage" :chooeseLanguageName="chooeseLanguageName"
        @chooeselanguage="chooeselanguage" />
      <button class="generate-button" @click="generateNotes">
        Generate Notes
      </button>

    </div>
  </div>
</template>

<script>
import selectlanguage from "@/views/pages/home_page/popups/selectlanguage.vue";
export default {
  name: "YouTubeModal",
  components: {
    selectlanguage,
  },
  data() {
    return {
      youtobelogo: require("../../../../assets/images/index/youtubelogo.svg"),
      bilibililogo: require("../../../../assets/images/index/bilibililogo.png"),
      youtubeLink: "",
      isVisible: false,
      chooeseLanguage: "",
      chooeseLanguageName: "",
    };
  },
  methods: {
    chooeselanguage(language, Languagename) {
      this.chooeseLanguage = language
      this.chooeseLanguageName = Languagename
      this.$emit("chooeselanguage", language, Languagename)
    },
    openModal() {
      this.isVisible = true;
      this.$nextTick(() => {
        this.$refs.videoInput.focus();
      });
    },
    closeModal() {
      this.isVisible = false;
    },
    generateNotes() {
      // 这里添加生成笔记的逻辑
      // 获取并判断当前域名 如果包含easynoteai.com 则使用checkLink1
      // 否则使用checkLink2
      // const web_domain = window.location.hostname
      let checkLink = this.checkLink2()
      // if (web_domain.includes('easynoteai.com')) {
      //   checkLink = this.checkLink1()
      // }

      if (!checkLink) {
        this.$message.error("Invalid YouTube URL. Please enter a valid URL from youtube.com or youtu.be.");
        return;
      }
      if (this.chooeseLanguageName == "" || !this.chooeseLanguageName) {
        this.$message.error("Please select a language first.");
        return;
      }
      // console.log("Generating notes for:", this.youtubeLink);
      this.$emit("createnotevideo", this.youtubeLink);
    },
    checkLink1() {
      const youtubeUrlPattern = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
        "(www\\.)?" + // www.
        "(youtube\\.com|youtu\\.be)" + // domain name
        "\\/.*" // path
      );
      this.linkValid =
        youtubeUrlPattern.test(this.youtubeLink) && this.youtubeLink !== "";
      return this.linkValid;
    },
    checkLink2() {
      // YouTube链接正则
      const youtubeUrlPattern = new RegExp(
        "^(https?:\\/\\/)?" + // 协议
        "(www\\.)?" + // www.
        "(youtube\\.com|youtu\\.be)" + // YouTube域名
        "\\/.*" // 路径
      );

      // this.linkValid = youtubeUrlPattern.test(this.youtubeLink) && this.youtubeLink !== "";

      // 暂时不用
      // Bilibili视频链接正则
      const bilibiliUrlPattern = new RegExp(
        "^(https?:\\/\\/)?" + // 协议
        "(www\\.)?" + // www.
        "bilibili\\.com\\/video\\/(" + // bilibili视频路径
        "BV[0-9A-Za-z]{10}|" + // BV号格式
        "av[0-9]+)" // av号格式
      );

      // 检查是否为YouTube或Bilibili链接
      this.linkValid = (
        (youtubeUrlPattern.test(this.youtubeLink) || 
        bilibiliUrlPattern.test(this.youtubeLink)) && 
        this.youtubeLink !== ""
      );
      return this.linkValid;
    },
  },
};
</script>

<style lang="less" scoped>
.modal-video {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .modal-content {
    background-color: #ffffff;
    border-radius: 16px;
    padding: 32px;
    width: 500px;
    max-width: 90%;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  }

  .modal-header {
    text-align: center;
    margin-bottom: 28px;

    .youtube-icon {
      width: 140px;
      height: 60px;
      margin: 12px auto;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 20px;
      img {
        width: 60px;
        height: 60px;
        object-fit: contain;
      }
      .bilibili-icon {
        width: 65px;
        height: 65px;
        object-fit: contain;
      }
    }

    h2 {
      color: #1a1a1a;
      font-size: 20px;
      font-weight: 600;
      margin: 20px 0 0;
      line-height: 1.4;
    }
  }

  .input-container {
    margin-bottom: 20px;

    input {
      width: 100%;
      padding: 14px 16px;
      border-radius: 12px;
      border: 1px solid #e0e0e0;
      background-color: #f8f9fa;
      color: #333333;
      font-size: 15px;
      transition: all 0.2s ease;
      box-sizing: border-box;

      &:focus {
        outline: none;
        border-color: #4a90e2;
        box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.1);
        background-color: #ffffff;
      }

      &::placeholder {
        color: #999999;
      }
    }
  }

  .generate-button {
    background-color: #4a90e2;
    color: white;
    border: none;
    border-radius: 12px;
    padding: 14px;
    width: 100%;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    margin: 24px 0 0;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(74, 144, 226, 0.2);

    &:hover {
      background-color: #357abd;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
    }
    
    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
      transform: none;
      box-shadow: none;
    }
  }
}
</style>
